import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Table } from 'react-bootstrap';

// Constant inline styles outside component to avoid re-creation on render
const styles = {
  div1: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "inherit",
    padding: "3px"
  },
  div2: {
    width: "80%",
    height: "80%",
    background: "#fff",
    boxShadow: "15px 15px 25px #ccc",
    borderRadius: "15px"
  },
  centerText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  table: {
    width: '45%'
  }
};

// Questionnaire configuration data array (28 questions total)
const QUESTIONS = [
  {
    id: 1,
    mostKey: 'P1',
    leastKey: 'P2',
    options: [
      'Entuzijastičan-inspirativan-oštrouman',
      'Odvažan-smeo-hrabar',
      'Diplomatičan-taktičan',
      'Zadovoljan'
    ]
  },
  {
    id: 2,
    mostKey: 'P3',
    leastKey: 'P4',
    options: [
      'Oprezan-pažljiv-smotren',
      'Određen-odlučan-postojan',
      'Ubedljiv-čvrsto uverljiv',
      'Dobar-prirodan-uljudan'
    ]
  },
  {
    id: 3,
    mostKey: 'P5',
    leastKey: 'P6',
    options: [
      'Prijateljski-prijatan-srdačan',
      'Tačan-brižljiv-precizan',
      'Otvoren-iskren',
      'Staložen-bezbrižan-smiren-ravnodušan'
    ]
  },
  {
    id: 4,
    mostKey: 'P7',
    leastKey: 'P8',
    options: [
      'Taktičan-komunikativan',
      'Kontrolisan-samokontolirajući',
      'Konevncionalan-tradicionalan',
      'Odlučan-brzo odlučuje'
    ]
  },
  {
    id: 5,
    mostKey: 'P9',
    leastKey: 'P10',
    options: [
      'Riskantan-preduzimljiv',
      'Uviđan-pronicjiv-saosećajan',
      'Društven-druželjubiv-prijateljski',
      'Umeren-ublažen-izbegavajući ekstremno'
    ]
  },
  {
    id: 6,
    mostKey: 'P11',
    leastKey: 'P12',
    options: [
      'Blag-tih-lubazan',
      'Podsticajan-energičan-ubeljiv',
      'Ponizan-skroman-umeren',
      'Originalan-preduzimljiv'
    ]
  },
  {
    id: 7,
    mostKey: 'P13',
    leastKey: 'P14',
    options: [
      'Izražajan-osećajan',
      'Savestan-precizan',
      'Dominantan-kontrolisan-zapovednik',
      'Odgovoran-osećajan'
    ]
  },
  {
    id: 8,
    mostKey: 'P15',
    leastKey: 'P16',
    options: [
      'Staložen-usklađen-uravnotežen',
      'Pažliv-promišljen-predan',
      'Skroman-nezahtevan',
      'Nestrpljiv-nemiran-željan'
    ]
  },
  {
    id: 9,
    mostKey: 'P17',
    leastKey: 'P18',
    options: [
      'Taktičan-umešan',
      'Dopadljiv-ugodan-prijatan',
      'Privlačan-atraktivan',
      'Nepopustljiv-istrajan-insistirajući'
    ]
  },
  {
    id: 10,
    mostKey: 'P19',
    leastKey: 'P20',
    options: [
      'Neustrašiv-hrabar',
      'Inspirativan-entuzijastičan-stimulativan',
      'Poslušan-pokoran-ponizan',
      'Bojažljiv-stidljiv'
    ]
  },
  {
    id: 11,
    mostKey: 'P21',
    leastKey: 'P22',
    options: [
      'Rezervisan-mrzovoljan-uzdržljiv',
      'Uslužan-uljudan-učtiv',
      'Jak-voljan-određen',
      'Veseo-srdačan'
    ]
  },
  {
    id: 12,
    mostKey: 'P23',
    leastKey: 'P24',
    options: [
      'Stimulativan-podsticajan-eksitator',
      'Ljubazan-prijateljski',
      'Predusretljiv-osetljiv-uviđavan',
      'Nezavisan-samostalan'
    ]
  },
  {
    id: 13,
    mostKey: 'P25',
    leastKey: 'P26',
    options: [
      'Konkurentan-ima jaku potrebu da pobedi',
      'Obziran-mudar',
      'Radostan-veseo',
      'Rezervisan-zatvoren'
    ]
  },
  {
    id: 14,
    mostKey: 'P27',
    leastKey: 'P28',
    options: [
      'Upošljen-osetljiv-probirački',
      'Poslušan-odgovoran',
      'Nepokolebljiv-strog-odlučan-čvrst',
      'Šaljiv(zabavan)'
    ]
  },
  {
    id: 15,
    mostKey: 'P29',
    leastKey: 'P30',
    options: [
      'Atraktivan- dobrog izgleda',
      'Samoktiričan - istražuje nečije mišljenje',
      'Jogunast- tvrdoglav -nefleksibilan',
      'Predvidljiv'
    ]
  },
  {
    id: 16,
    mostKey: 'P31',
    leastKey: 'P32',
    options: [
      'Logičan-racionalan',
      'Preduzimljiv-drzak-hrabar',
      'Lojalan-Veran-nepopustljiv-uravnotežen',
      'Šarmantan-izvrstan-očaravajući'
    ]
  },
  {
    id: 17,
    mostKey: 'P33',
    leastKey: 'P34',
    options: [
      'Druževan-društven',
      'Strpljiv',
      'Samouveren-svojeglav-poverljiv',
      'Mekan-slatkorečiv-nežan'
    ]
  },
  {
    id: 18,
    mostKey: 'P35',
    leastKey: 'P36',
    options: [
      'Voljan-spreman da preduzme',
      'Željan da uči-bistar-entuzijastičan',
      'Temelj-precizan',
      'Ugledan-vatren-živahan-veseo'
    ]
  },
  {
    id: 19,
    mostKey: 'P37',
    leastKey: 'P38',
    options: [
      'Agresivan-neprijateljski',
      'Slobodan-društven',
      'Ljubazan-blagonaklon-prijateljski',
      'Plašljiv-uplašen'
    ]
  },
  {
    id: 20,
    mostKey: 'P39',
    leastKey: 'P40',
    options: [
      'Poverljiv-samouveren',
      'Samoosećajan-razumljiv',
      'Nepristrasan-nesebična',
      'Uporan-prediktivan'
    ]
  },
  {
    id: 21,
    mostKey: 'P41',
    leastKey: 'P42',
    options: [
      'Dobro-disciplinovan-samokontrolisan',
      'Darežliv-berićetan',
      'Razigran-vedar',
      'Izdržljiv-prediktivan'
    ]
  },
  {
    id: 22,
    mostKey: 'P43',
    leastKey: 'P44',
    options: [
      'Impulsivan-nestrpljiv',
      'Introvertan-reztervisan',
      'Moćan-snažan-određen-nepokolebljiv',
      'Jednostavan-spokojan-tolerantan'
    ]
  },
  {
    id: 23,
    mostKey: 'P45',
    leastKey: 'P46',
    options: [
      'Dobar-kombinator',
      'Rafiniran-pametan-uglađen-kulturan',
      'Snažan-čvrst',
      'Blag-predaje se-milostiv'
    ]
  },
  {
    id: 24,
    mostKey: 'P47',
    leastKey: 'P48',
    options: [
      'Osvajač-fascinantan',
      'Zadovoljan-srećan',
      'Zahtevan-pretenciozan',
      'Predusetljiv-pokoran-popustljiv'
    ]
  },
  {
    id: 25,
    mostKey: 'P49',
    leastKey: 'P50',
    options: [
      'Svadljiv-prgav',
      'Sistematičan-metodičan-uredan',
      'Kooperativan-voljan',
      'Radostan-raspoložen'
    ]
  },
  {
    id: 26,
    mostKey: 'P51',
    leastKey: 'P52',
    options: [
      'Razdragan-veseo-srećan-živahan',
      'Precizan-tačan',
      'Direktan-pravolinijski-iskren',
      'skladan-uravnotežen'
    ]
  },
  {
    id: 27,
    mostKey: 'P53',
    leastKey: 'P54',
    options: [
      'Nespokojan-uznemiren',
      'Prijateljski za okolinu',
      'Umiljat-privlačan',
      'Pažliv-smotren'
    ]
  },
  {
    id: 28,
    mostKey: 'P55',
    leastKey: 'P56',
    options: [
      'Pokazuje poštovanje',
      'Pronicljiv smeo',
      'Optimista',
      'Koristan'
    ]
  }
];

class PersonalityTest extends Component {
  constructor(props) {
    super(props);
    
    // Initialize P1 to P56 dynamic fields cleanly
    const answersState = {};
    for (let i = 1; i <= 56; i++) {
      answersState[`P${i}`] = '0';
    }

    this.state = {
      ...answersState,
      minutes: 10,
      seconds: 3
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.timer = this.timer.bind(this);
    this.startTimer = this.startTimer.bind(this);
  }

  async componentDidMount() {
    // this.startTimer();
    try {
      const resp = await axios.post('/api/personalityApi/checkIfTestIsAccessed/');
      if (resp.data.message === true) {
        Swal.fire(
          'Problem',
          'Test je već rađen sa ovog naloga!',
          'error'
        );
        this.props.history.push('/welcomePage');
      }
    } catch (err) {
      console.log(err);
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  startTimer() {
    if (this.state.minutes !== 0 || this.state.seconds !== 0) {
      this.interval = setInterval(this.timer, 1000);
    }
  }

  timer() {
    const { minutes, seconds } = this.state;
    if (seconds === 0 && minutes !== 0) {
      this.setState(prevState => ({
        minutes: prevState.minutes - 1,
        seconds: 59
      }));
    } else if (seconds === 0 && minutes === 0) {
      clearInterval(this.interval);
      const email = this.props.auth.user.company === "Group" 
        ? "tanja.petrovic@galeb.com" 
        : "jovana.markovic@galeb.com";
      
      Swal.fire(
        'Problem',
        `Vreme za predaju testa je isteklo, javi se na e-mail adresu ${email} da ponovo pristupis testu!`,
        'error'
      );
      this.props.history.push('/welcomePage');
    } else if (seconds > 0) {
      this.setState(prevState => ({
        seconds: prevState.seconds - 1
      }));
    }
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmit(e) {
    e.preventDefault();
    
    Swal.fire({
      title: 'Da li sigurno želiš da predaš test?',
      text: "Nećeš moći da ga radiš ponovo",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Ček da proverim',
      confirmButtonText: 'Predaj!'
    }).then(async (result) => {
      // Validate all P1 - P56 fields are answered
      for (let i = 1; i <= 56; i++) {
        if (this.state[`P${i}`] === '0') {
          Swal.fire(
            'Test nije popunjen!',
            'Niste dali odgovore na sva pitanja!',
            'error'
          );
          return;
        }
      }

      if (result.isConfirmed) {
        const data = {};
        for (let i = 1; i <= 56; i++) {
          data[`P${i}`] = this.state[`P${i}`];
        }

        try {
          const resp = await axios.post('/api/personalityApi/saveTestResult', data);
          console.log(resp);
          Swal.fire(
            'Poslato!',
            resp.data.message,
            resp.data.sign
          );
          this.props.history.push('/welcomePage');
        } catch (err) {
          console.log(err);
        }
      }
    });
  }

  renderQuestionTable = (question) => {
    const { id, mostKey, leastKey, options } = question;
    const mostVal = this.state[mostKey];
    const leastVal = this.state[leastKey];

    return (
      <div style={styles.centerText} key={`q-${id}`}>
        <Table striped bordered hover variant="grey" style={styles.table}>
          <tbody>
            <tr>
              <td>Pitanje {id}.</td>
              <td style={{ textAlign: 'center' }}>Najviše</td>
              <td style={{ textAlign: 'center' }}>Najmanje</td>
            </tr>
            {options.map((optValue, idx) => (
              <tr key={idx}>
                <td>{optValue}</td>
                <td style={{ textAlign: 'center' }}>
                  <input
                    required={idx === 0}
                    disabled={leastVal === optValue}
                    onChange={this.onChange}
                    type="radio"
                    name={mostKey}
                    value={optValue}
                    checked={mostVal === optValue}
                    className="form-check-input"
                  />
                </td>
                <td style={{ textAlign: 'center' }}>
                  <input
                    required={idx === 0}
                    disabled={mostVal === optValue}
                    onChange={this.onChange}
                    type="radio"
                    name={leastKey}
                    value={optValue}
                    checked={leastVal === optValue}
                    className="form-check-input"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  };

  render() {
    const userName = this.props.auth?.user?.name || '';

    return (
      <div className='content'>
        <div style={styles.div1}>
          <div style={styles.div2}>
            <div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
              <div style={{ padding: "16px 0", textAlign: "left" }}>
                <br /><br />
                <div style={styles.centerText}>
                  Zdravo {userName} ,pred tobom je test ličnosti, iskreno odgovori na pitanja!
                </div>
                <br /><br /><br />
                
                {QUESTIONS.map(q => (
                  <React.Fragment key={q.id}>
                    {this.renderQuestionTable(q)}
                    <br /><br />
                  </React.Fragment>
                ))}

                <div style={styles.centerText}>
                  <input
                    type="submit"
                    value="Predaj test"
                    onClick={this.onSubmit}
                    className="btn-fill col-md-3 pull-center btn btn-info"
                    style={{ margin: '3px' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(
  mapStateToProps
)(PersonalityTest);